import Axios from 'axios'

// constant
import * as types from '../types'
import { host } from '../../../../host'

// helper
import catchErrorApi from '../../../../helper/catchErrorApi'
import autoDownloadFromBlob from '../../../../helper/autoDownloadFromBlob'
import { removeLoading, addLoading } from '../../../commonAction'
import sortListStringNum from '../../../../helper/sortLIstStringNum'

const apiGetListDuplicatedFace = `${host}admin/exportJSON/reportDuplicatedFace`

export const getListDuplicatedFace = ({
    FromDate,
    ToDate,
    BranchIDs,
    ReportCodeName,
    BranchName,
    ChannelCurrentCustomer,
    ChannelDuplicatedCustomer,
    SupervisorCurrentCustomer,
    SupervisorDuplicatedCustomer,
    TellerCurrentCustomer,
    TellerDuplicatedCustomer
}) => async (dispatch) => {
    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ReportCodeName,
        BranchName,
        ChannelCurrentCustomer,
        ChannelDuplicatedCustomer,
        SupervisorCurrentCustomer,
        SupervisorDuplicatedCustomer,
        TellerCurrentCustomer,
        TellerDuplicatedCustomer
    })

    try {
        const res = await Axios.post(apiGetListDuplicatedFace, dataRequest)
        const { data } = res
        dispatch({
            type: types.GET_LIST_DUPLICATED_FACE,
            payload: {
                condFilter: {
                    FromDate,
                    ToDate,
                    BranchIDs,
                    ReportCodeName,
                    BranchName,
                    ChannelCurrentCustomer,
                    ChannelDuplicatedCustomer,
                    SupervisorCurrentCustomer,
                    SupervisorDuplicatedCustomer,
                    TellerCurrentCustomer,
                    TellerDuplicatedCustomer
                },
                listData: data.Data || [],
            },
        })
        dispatch(removeLoading())
    } catch (err) {
        dispatch(removeLoading())
        catchErrorApi(
            err,
            dispatch,
            types.GET_LIST_DUPLICATED_FACE_ERROR,
            () => false
        )
    }
}

export const exportListDuplicatedFace = ({
    FromDate,
    ToDate,
    BranchIDs,
    ReportCodeName,
    BranchName,
    BranchCodes,
    ChannelCurrentCustomer,
    ChannelDuplicatedCustomer,
    SupervisorCurrentCustomer,
    SupervisorDuplicatedCustomer,
    TellerCurrentCustomer,
    TellerDuplicatedCustomer
}) => async (dispatch) => {
    if (!BranchCodes) return

    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ExportExcel: true,
        ReportCodeName,
        BranchName,
        ChannelCurrentCustomer,
        ChannelDuplicatedCustomer,
        SupervisorCurrentCustomer,
        SupervisorDuplicatedCustomer,
        TellerCurrentCustomer,
        TellerDuplicatedCustomer
    })

    try {
        const res = await Axios.post(apiGetListDuplicatedFace, dataRequest, {
            responseType: 'blob',
        })
        dispatch(removeLoading())
        const { data } = res
        if (BranchCodes.length === 1) {
            autoDownloadFromBlob(data, `${ReportCodeName}-${BranchCodes[0]}`)
        } else {
            autoDownloadFromBlob(
                data,
                `${ReportCodeName}-${sortListStringNum(BranchCodes).join('-')}`
            )
        }
    } catch (err) {
        dispatch(removeLoading())
        console.log(err)
    }
}
